"use client";

import { createContext, useContext, useState } from 'react';

interface SidebarContextValue { open: boolean; toggle: () => void; close: () => void; }
const SidebarContext = createContext<SidebarContextValue>({ open: false, toggle: () => {}, close: () => {} });

export function SidebarProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <SidebarContext.Provider value={{ open, toggle: () => setOpen(v => !v), close: () => setOpen(false) }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() { return useContext(SidebarContext); }
